// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Permissions * {
  color: var(--bs-primary);
}`, "",{"version":3,"sources":["webpack://./src/pages/Roles/styles.scss"],"names":[],"mappings":"AACE;EACE,wBAAA;AAAJ","sourcesContent":[".Permissions {\n  * {\n    color: var(--bs-primary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
